import React, { useState } from "react";
import { Carousel } from "antd";
import { Link } from "react-router-dom";

const MoreToExplore = ({ isMobile, categories }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Adjusts the center card size based on index
  const getCardClassName = (index) => {
    return index === currentSlide
      ? "transform scale-105"
      : "transform scale-90 mt-12";
  };

  return (
    <div className="py-5 md:py-10">
      <div className="flex justify-center">
        <p
          className={`text-center uppercase border-b border-[#d7d4d4] font-semibold leading-[34px] ${
            isMobile ? "text-lg mb-5" : "text-2xl md:mb-8 "
          }`}
        >
          More To Explore
        </p>
      </div>
      <Carousel
        dots={false}
        arrows
        infinite
        autoplay
        autoplaySpeed={3000}
        slidesToShow={isMobile ? 1 : 3}
        centerMode
        centerPadding={isMobile ? "50px" : "0"}
        draggable
        afterChange={(current) => setCurrentSlide(current)}
        responsive={[
          { breakpoint: 1024, settings: { slidesToShow: 3, centerPadding: "0" } },
          { breakpoint: 768, settings: { slidesToShow: 1, centerPadding: "50px" } },
          { breakpoint: 480, settings: { slidesToShow: 1, centerPadding: "50px" } },
        ]}
      >
        {categories?.map((category, index) => (
          <div
            key={index}
            className={`px-2 cursor-pointer text-center ${getCardClassName(index)}`}
          >
            <Link to={category.link} className="hover:text-black">
            <div
              className="product-image-container relative overflow-hidden"
              style={{
                height: isMobile
                  ? index === currentSlide
                    ? "300px"
                    : "250px" // Smaller height for adjacent cards on mobile
                  : index === currentSlide
                  ? "550px"
                  : "500px", // Default heights for desktop
              }}
            >
              <img
                src={category.image}
                alt={category.name}
                className="w-full h-full object-cover transition duration-300"
              />
            </div>
            <div className="md:h-40 h-24">

            <p
              className={`font-bold mt-5 mb-2 tracking-wide ${
                isMobile ? "text-lg" : "text-3xl"
              }`}
            >
              {category.name}
            </p>
            <div className="flex justify-center">
              <p
                className={`tracking-widest line-clamp-2 w-3/4 ${
                  isMobile ? "text-xs" : "text-lg"
                }`}
              >
                {category.description}
              </p>
            </div>
            </div>
</Link>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default MoreToExplore;
